import { NavLink } from 'react-router-dom';
import IconChangeLogClock from '../icons/change-log-clock';
import IconLoader from '../icons/loader';
import { PermissionEnum } from '../../base-types';
import ChangeLogItem from './chage-log-item';
import { ChangeLogsTypes } from './types';
import ButtonSecondary from '../button/button-secondary';
import { ButtonSize } from '../button/types';

import styles from './change-logs.module.css';

export default function ChangeLogs({
  entityType,
  entityId,
  changeLogs,
  changeLogsIsLoading,
  activePermission,
  users,
  changeLogsIsFetching,
  pagination,
  getChangeLogs,
}: ChangeLogsTypes) {
  let content;

  if (!activePermission?.includes(PermissionEnum.AUDIT_LOG_LIST)) {
    content = (
      <div className={styles.emptyLogs}>
        You don&apos;t have access to this section
      </div>
    );
  } else if (activePermission?.includes(PermissionEnum.AUDIT_LOG_LIST)) {
    if (changeLogsIsLoading || (changeLogsIsFetching && !changeLogs?.length)) {
      content = (
        <div className={styles.logsLoader}>
          <IconLoader />
        </div>
      );
    } else if (!changeLogsIsLoading && !changeLogs?.length) {
      content = <div className={styles.emptyLogs}>No change logs yet</div>;
    } else if (!changeLogsIsLoading && changeLogs && changeLogs.length > 0) {
      content = (
        <div className={styles.changeLogsList}>
          {changeLogs?.map((item) => (
            <ChangeLogItem key={item.id} changeLog={item} users={users} />
          ))}
          {pagination?.hasNextPage && getChangeLogs && (
            <ButtonSecondary
              text={changeLogsIsFetching ? 'Loading...' : 'Show more'}
              size={ButtonSize.SMALL}
              className={styles.showMoreButton}
              onClick={() => getChangeLogs(pagination.endCursor)}
            />
          )}
        </div>
      );
    }
  }

  return (
    <div className={styles.changeLogsWrapper}>
      <div className={styles.changeLogsTitleWrapper}>
        <div className={styles.changeLogsTitle}>Change Logs</div>
        {activePermission?.includes(PermissionEnum.AUDIT_LOG_LIST) && (
          <NavLink
            to={`/administration/change-logs?${
              typeof entityType === 'string'
                ? `entityType=${entityType}`
                : `entityType=${entityType?.join('&entityType=')}`
            }&entityId=${entityId}`}
            target="_blank"
            className={styles.changeLogLink}
          >
            <IconChangeLogClock />
            Change Log
          </NavLink>
        )}
      </div>
      {content}
    </div>
  );
}
